import script from "./OrderBasisInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBasisInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBasisInfoModal.vue?vue&type=style&index=0&id=4727c836&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4727c836"]])

export default __exports__